/* ============================================================
   ADEQO COLLECTION LANDING — interaction script
   Handles: setup-tabs switching · calculator m²/TV → panel count
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Setup Tabs ---------- */
  function initSetupTabs(root) {
    var tabs   = root.querySelectorAll('[data-setup-tab]');
    var panels = root.querySelectorAll('[data-setup-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-setup-tab');

        tabs.forEach(function (t) {
          var isActive = t.getAttribute('data-setup-tab') === idx;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-setup-panel') === idx);
        });
      });
    });
  }

  /* ---------- Systeemblok: kleurwissel ---------- */
  function initSystem(root) {
    var buttons = root.querySelectorAll('[data-system-colour-btn]');
    if (buttons.length < 2) return;

    /* Elementen zonder data-attribuut horen bij elke kleur (de onderbalk, de clips)
       en worden daarom nooit aangeraakt. */
    var options = root.querySelectorAll('[data-system-option]');
    var visuals = root.querySelectorAll('[data-system-visual]');

    function apply(key) {
      root.setAttribute('data-system-active', key);

      buttons.forEach(function (b) {
        var isActive = b.getAttribute('data-system-colour-btn') === key;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      options.forEach(function (o) {
        o.classList.toggle('is-hidden', o.getAttribute('data-system-option') !== key);
      });

      visuals.forEach(function (v) {
        v.classList.toggle('is-hidden', v.getAttribute('data-system-visual') !== key);
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.getAttribute('data-system-colour-btn'));
      });
    });
  }

  /* ---------- Calculator ---------- */
  function initCalculator(root) {
    var type    = root.getAttribute('data-calc-type') || 'wall-coverage';
    var input   = root.querySelector('[data-calc-input]');
    var outM2   = root.querySelector('[data-calc-output-m2]');
    var outPan  = root.querySelector('[data-calc-output-panels]');
    var products = root.querySelectorAll('[data-calc-product]');
    if (!input) return;

    // TV diagonal (inches) → recommended wall area (m²)
    // Heuristic: ideal acoustic wall is ~1.5x TV diagonal width
    // 1 inch = 2.54 cm. 16:9 ratio: width = diag * 0.872
    function tvToM2(inches) {
      var diagCm = inches * 2.54;
      var widthM = (diagCm * 0.872) / 100;
      var idealWidth = widthM * 1.5;
      var idealHeight = idealWidth * 0.5625;
      return Math.max(idealWidth * idealHeight, 4);
    }

    function getM2() {
      var raw = parseFloat(input.value);
      if (isNaN(raw) || raw <= 0) return 0;
      if (type === 'tv') return tvToM2(raw);
      return raw;
    }

    function update() {
      var m2 = getM2();
      if (outM2) outM2.textContent = m2 ? m2.toFixed(1) + ' m²' : '—';

      // Use first product's m2_per_panel as reference, fallback 0.45
      var m2PerPanel = 0.45;
      if (products.length) {
        var ref = parseFloat(products[0].getAttribute('data-m2-per-panel'));
        if (!isNaN(ref) && ref > 0) m2PerPanel = ref;
      }

      var panels = m2 > 0 ? Math.ceil(m2 / m2PerPanel) : 0;
      if (outPan) outPan.textContent = panels ? panels + ' stuks' : '—';

      // Update per-product output if multiple products with different m2/panel
      products.forEach(function (p) {
        var perPanel = parseFloat(p.getAttribute('data-m2-per-panel')) || m2PerPanel;
        var qty = m2 > 0 ? Math.ceil(m2 / perPanel) : 0;
        var qtyEl = p.querySelector('[data-calc-product-qty]');
        if (qtyEl) qtyEl.textContent = qty;
      });
    }

    input.addEventListener('input', update);
    update();
  }

  /* ---------- Lifestyle hotspots ---------- */
  function initLifestyleHotspots() {
    var hotspots = document.querySelectorAll('.col-lifestyle__hotspot');
    if (!hotspots.length) return;

    function closeAll(except) {
      hotspots.forEach(function (h) {
        if (h === except) return;
        h.classList.remove('is-open');
        var b = h.querySelector('.col-lifestyle__dot');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    hotspots.forEach(function (hotspot) {
      var btn = hotspot.querySelector('.col-lifestyle__dot');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = hotspot.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) closeAll(hotspot);
      });
    });

    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* ---------- Horizontale scroll-hint ----------
     Zet is-scrollable / is-scroll-start / is-scroll-end op het blok rond een
     horizontaal scrollbaar gebied. Daar hangen de veeg-hint, de rand-fade en
     de schaduw langs de vastgezette kolom aan vast. */
  function initScrollHints() {
    document.querySelectorAll('[data-col-scroll]').forEach(function (block) {
      var area = block.querySelector('[data-col-scroll-area]');
      if (!area) return;

      function update() {
        var max = area.scrollWidth - area.clientWidth;
        var scrollable = max > 4;
        var left = area.scrollLeft;

        block.classList.toggle('is-scrollable', scrollable);
        block.classList.toggle('is-scroll-start', !scrollable || left <= 2);
        block.classList.toggle('is-scroll-end', !scrollable || left >= max - 2);
      }

      area.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Herbereken als de tabel van hoogte/breedte verandert (webfont, beeld)
      if (window.ResizeObserver) {
        new ResizeObserver(update).observe(area);
      }

      update();
    });
  }

  /* ---------- Init ---------- */
  function init() {
    document.querySelectorAll('[data-col-setup-tabs]').forEach(initSetupTabs);
    document.querySelectorAll('[data-col-system]').forEach(initSystem);
    document.querySelectorAll('[data-col-calculator]').forEach(initCalculator);
    initLifestyleHotspots();
    initScrollHints();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
